import AdminToolReportSection from "./AdminToolReportSection";

export default AdminToolReportSection;
export type { AdminToolReportSectionProps } from "./AdminToolReportSection.types";
